enum PaymentTypes {
  Unknown = 0,
  AmericanExpress = 1,
  Visa = 2,
  MasterCard = 3,
  DinersClub = 4,
  Discover = 5,
  Financing = 6,
  Debit = 7,
  Checking = 8,
  Savings = 9,
  CorporateChecking = 10,
  CorporateSavings = 11
}

export default PaymentTypes;

export const paymentMethodACH = [
  PaymentTypes.Checking,
  PaymentTypes.Savings,
  PaymentTypes.CorporateChecking,
  PaymentTypes.CorporateSavings
];
